import VesselVoyageValidationSchema from '../validationschema/VesselVoyageValidationSchema'

function useAddScheduleValidationSchema() {
    return VesselVoyageValidationSchema()
}
export default useAddScheduleValidationSchema